function formatUnitTotal(value) {
  return value % 1 === 0 ? value.toFixed(0) : parseFloat(value.toFixed(2)).toString();
}

if (!customElements.get('unit-weight-quantity')) {
  class UnitWeightQuantity extends HTMLElement {
    connectedCallback() {
      this.unitValue = parseFloat(this.dataset.unitValue || this.dataset.unitWeight);
      this.mode = this.dataset.mode || 'product';
      this.qtyInput = this.querySelector('[data-uw-qty-input]');
      this.weightProperty = this.querySelector('[data-uw-weight-property]');
      this.display = this.querySelector('[data-uw-display]');

      this.pieces = parseInt(this.qtyInput?.value, 10) || 1;
      if (this.pieces < 1 || Number.isNaN(this.pieces)) {
        this.pieces = 1;
      }

      this.querySelector('[data-uw-minus]')?.addEventListener('click', () => this.changePieces(-1));
      this.querySelector('[data-uw-plus]')?.addEventListener('click', () => this.changePieces(1));
      this.updateAll();
    }

    getBillingQty() {
      return this.pieces;
    }

    getWeightLabel() {
      const suffix = this.dataset.unitSuffix || 'Kg';
      return `${formatUnitTotal(this.pieces * this.unitValue)} ${suffix}`.trim();
    }

    changePieces(delta) {
      const newPieces = this.pieces + delta;
      if (newPieces < 1) return;

      this.pieces = newPieces;
      this.updateAll();

      if (this.mode === 'cart' && this.qtyInput) {
        this.qtyInput.dataset.initialValue = String(this.pieces);
        this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    updateAll() {
      const weightLabel = this.getWeightLabel();
      const billingQty = this.getBillingQty();

      if (this.display) {
        this.display.value = weightLabel;
      }

      if (this.weightProperty) {
        this.weightProperty.value = weightLabel;
      }

      if (this.qtyInput) {
        this.qtyInput.value = String(billingQty);
        this.dataset.billingQty = String(billingQty);
      }
    }
  }

  customElements.define('unit-weight-quantity', UnitWeightQuantity);
}
